import Prism from 'prismjs';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-csv';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-markdown.js';
import 'prismjs/components/prism-markup-templating.js'; // is required for php
import 'prismjs/components/prism-php.js';
import 'prismjs/components/prism-regex.js';
import 'prismjs/components/prism-sass.js';
import 'prismjs/components/prism-shell-session.js';
import 'prismjs/components/prism-sql.js';
import 'prismjs/components/prism-typescript.js';